import React, { useMemo } from "react";

const RULES = [
  { test: (p) => p.length >= 8, label: "8+ characters" },
  { test: (p) => /[A-Z]/.test(p), label: "Uppercase" },
  { test: (p) => /[a-z]/.test(p), label: "Lowercase" },
  { test: (p) => /\d/.test(p), label: "Number" },
  { test: (p) => /[^A-Za-z0-9]/.test(p), label: "Symbol" },
];

const LABELS = ["Weak", "Fair", "Good", "Strong", "Very strong"];
const COLORS = ["#ef4444", "#f59e0b", "#eab308", "#22c55e", "#0A3B40"];

export default function PasswordStrength({ password = "", className = "" }) {
  const { score, label, color, missing } = useMemo(() => {
    const s = RULES.reduce((acc, r) => acc + (r.test(password) ? 1 : 0), 0);
    return {
      score: s,
      label: LABELS[Math.max(0, s - 1)] || LABELS[0],
      color: COLORS[Math.max(0, s - 1)] || COLORS[0],
      missing: RULES.filter(r => !r.test(password)).slice(0, 2).map(r => r.label).join(" · "),
    };
  }, [password]);

  if (!password) return null;

  return (
    <div className={className} data-testid="password-strength">
      <div className="flex gap-1">
        {[1, 2, 3, 4, 5].map(i => (
          <div key={i} className="h-1 flex-1 rounded-full transition-colors" style={{ background: i <= score ? color : "hsl(var(--muted))" }} />
        ))}
      </div>
      <div className="mt-1.5 flex items-center justify-between text-[11px]">
        <span style={{ color }} className="font-medium">{label}</span>
        <span className="text-muted-foreground">{missing}</span>
      </div>
    </div>
  );
}
